<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title
              >Ticket History (last {{ history.length }})</v-toolbar-title
            >
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="history"
              :items-per-page="-1"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import moment from "moment";
export default {
  name: "TicketHistoryView",
  data() {
    return {
      history: [],
      interval: null,
      headers: [
        {
          text: "Zendesk ID",
          value: "zendesk_id",
        },
        {
          text: "Agent",
          value: "agent_email",
        },
        {
          text: "Expected Agent",
          value: "expected_agent",
        },
        {
          text: "Subject",
          value: "subject",
        },
        {
          text: "Skipped Agents",
          value: "skipped_agents",
        },
        {
          text: "Date",
          value: "created_at",
        },
      ],
    };
  },
  mounted() {
    this.getData();
    this.interval = setInterval(() => {
      this.getData();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    getData() {
      axios.get("/api/v1/ticket/history/latest").then((res) => {
        this.history = res.data;
      });
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped></style>
